// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3833) return "static/css/3833.d6ce8a29e8dbc7bf0642.css";
	if (chunkId === 8958) return "static/css/sender.d34f1d4efce43ae0fdfd.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"638":"dde7397c80c026292b38","6559":"b2e5d3c087a7fdcef4f6","7215":"b8f4477c3c1ea7c44bc8"}[chunkId] + ".chunk.css";
};